import { FiChevronRight } from "react-icons/fi";
import { FaReact, FaServer, FaMobileAlt } from "react-icons/fa";
import { MdHub } from "react-icons/md";

export function renderbrowserMonitoring () {
    return (
  <div className="transition-opacity duration-300" id="apm-content">
    {/* Breadcrumb */}
    <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
      <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
      <FiChevronRight className="text-[14px]" />
      <span>Product Capabilities</span>
      <FiChevronRight className="text-[14px]" />
      <span className="text-[#1b140d] dark:text-white font-medium">Real User Monitoring (RUM)</span>
    </nav>

    {/* Header */}
    <div className="border-b border-border-color dark:border-border-dark pb-8 mb-10">
      <h1 className="text-3xl lg:text-5xl font-extrabold text-text-main dark:text-white tracking-tight mb-4 leading-tight">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">Real User Monitoring (RUM)</span> <br />
        & Digital Experience
      </h1>
      <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
        Experience every click and tap like never before with Netraa APM! Our BRUM and MRUM monitoring tracks real user interactions on web and mobile, revealing performance insights that help you optimize apps, boost speed, and delight users everywhere.      </p>
    </div>

   {/* Browser Monitoring Section */}
<section className="scroll-mt-24" id="browser-monitoring">

  {/* Section Header */}
  <div className="flex items-start sm:items-center gap-4 mb-6">
    <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 shadow-sm shrink-0">
      <span className="material-symbols-outlined text-[24px]">web</span>
    </div>

    <h2 className="text-xl sm:text-2xl font-bold text-text-main dark:text-white leading-tight">
      A) Browser Monitoring (Web Applications)
    </h2>
  </div>

  {/* Main Layout */}
  <div className="flex flex-col gap-8 w-full">

    {/* Browser Performance Panel */}
    <div className="bg-surface-light dark:bg-surface-dark p-1 rounded-xl shadow-xl border border-border-color dark:border-border-dark overflow-hidden">

      <div className="rounded-lg overflow-hidden flex flex-col h-full min-h-[400px] border border-border-color dark:border-border-dark">

        {/* Browser Header */}
        <div className="h-8 bg-surface-light dark:bg-surface-dark border-b border-border-color dark:border-border-dark flex items-center px-3 gap-2 overflow-hidden">

          <div className="flex gap-1.5 shrink-0">
            <div className="w-2.5 h-2.5 rounded-full bg-red-400"></div>
            <div className="w-2.5 h-2.5 rounded-full bg-amber-400"></div>
            <div className="w-2.5 h-2.5 rounded-full bg-green-400"></div>
          </div>

          <div className="flex-1 ml-2 bg-surface-light dark:bg-surface-dark h-5 rounded flex items-center px-2 text-[10px] text-text-muted font-mono overflow-hidden whitespace-nowrap text-ellipsis">
            https://app.netraa.io/dashboard/vitals
          </div>
        </div>

        {/* Content */}
        <div className="p-4 md:p-6 flex flex-col gap-8 flex-1">

          {/* Core Vitals */}
          <div>

            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 mb-4">

              <span className="text-xs font-bold uppercase text-text-muted tracking-wider">
                Web Performance (Core Vitals)
              </span>

              <span className="text-[10px] bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-bold self-start sm:self-auto">
                HEALTHY
              </span>
            </div>

            {/* Responsive Metrics Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

              {[
                { label: "LCP", value: "1.2s", color: "green-500", dash: "90,100" },
                { label: "FID", value: "18ms", color: "green-500", dash: "95,100" },
                { label: "CLS", value: "0.15", color: "orange-500", dash: "70,100" },
              ].map((metric, idx) => (

                <div
                  key={idx}
                  className="flex flex-col items-center p-3 bg-surface-light dark:bg-surface-dark rounded-xl border border-border-color dark:border-border-dark"
                >

                  <div className="relative w-16 h-16 flex items-center justify-center mb-1">

                    <svg
                      className="w-full h-full transform -rotate-90"
                      viewBox="0 0 36 36"
                    >

                      <path
                        className="text-gray-200 dark:text-gray-700"
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                      ></path>

                      <path
                        className={`text-${metric.color}`}
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        fill="none"
                        stroke="currentColor"
                        strokeDasharray={metric.dash}
                        strokeWidth="3"
                      ></path>
                    </svg>

                    <span className="absolute text-sm font-bold text-text-main dark:text-white">
                      {metric.value}
                    </span>
                  </div>

                  <span className="text-[10px] font-bold text-text-muted uppercase">
                    {metric.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="h-px bg-border-color dark:bg-border-dark"></div>

          {/* Trace Flow */}
          <div className="flex flex-col justify-center">

            <span className="text-xs font-bold uppercase text-text-muted tracking-wider mb-6">
              Click-to-Code Trace Flow
            </span>

            {/* MOBILE = vertical */}
            {/* DESKTOP = horizontal */}
            <div className="flex flex-col md:flex-row items-center justify-between relative z-10 gap-6 md:gap-0">

              {/* Checkout */}
              <div className="flex flex-col items-center gap-3 group cursor-pointer z-10">

                <div className="w-12 h-12 rounded-xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark flex items-center justify-center group-hover:border-orange-400 transition-colors">

                  <FaReact className="text-blue-500 text-2xl" />
                </div>

                <span className="text-[10px] font-mono text-text-muted font-bold bg-surface-light dark:bg-surface-dark px-2 py-0.5 rounded">
                  Checkout
                </span>
              </div>

              {/* Connector */}
              <div className="w-0.5 h-8 md:h-0.5 md:flex-1 bg-border-color dark:bg-border-dark relative mx-2 flex items-center justify-center">

                <div
  className="
    absolute

    /* Mobile: right side of vertical connector */
    left-3 top-1/2 -translate-y-1/2

    /* Desktop: above horizontal connector */
    md:left-1/2
    md:top-0
    md:-translate-x-1/2
    md:-translate-y-6

    text-[10px]
    text-red-600
    font-bold
    bg-red-50 dark:bg-red-900/20
    px-1.5 py-0.5
    rounded
    border border-red-100 dark:border-red-700
    whitespace-nowrap
  "
>
  500 ERROR
</div>
              </div>

              {/* API */}
              <div className="flex flex-col items-center gap-3 z-10">

                <div className="w-12 h-12 rounded-xl border-2 border-red-100 dark:border-red-700 bg-red-50 dark:bg-red-900/20 flex items-center justify-center node-error-glow">

                  <span className="material-symbols-outlined text-red-500 text-[24px]">
                    api
                  </span>
                </div>

                <span className="text-[10px] font-mono text-red-600 dark:text-red-300 font-bold bg-red-50 dark:bg-red-900/20 px-2 py-0.5 rounded border border-red-100 dark:border-red-700">
                  /api/buy
                </span>
              </div>

              {/* Connector */}
              <div className="w-0.5 h-8 md:h-0.5 md:flex-1 bg-border-color dark:bg-border-dark mx-2"></div>

              {/* Terminal */}
              <div className="flex flex-col items-center gap-3 z-10">

                <div className="w-12 h-12 rounded-xl border border-border-color dark:border-border-dark bg-surface-dark flex items-center justify-center shadow-lg">

                  <span className="material-symbols-outlined text-white text-[24px]">
                    terminal
                  </span>
                </div>

                <span className="text-[10px] font-mono text-text-main dark:text-white font-bold bg-surface-light dark:bg-surface-dark px-2 py-0.5 rounded text-center">
                  Java NullPtr
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Feature Cards */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">

      {[
        { icon: <FaReact />, title: "Total UI/Front-End Visibility", desc: "Capture every click, route change, and asset load time across your entire application." },
        { icon: <FaReact />, title: "Application-Based Logic", desc: "Define custom logic to group user interactions by business application domain." },
        { icon: <FaReact />, title: "Version Comparison (A/B)", desc: "Monitor specific deployments for A/B testing, canary releases, and feature flagging." },
        { icon: <FaReact />, title: "Application Page Routing", desc: "Automatic detection of single-page application (SPA) route changes and history states." },
        { icon: <FaServer />, title: "Distributed Traces/Logs", desc: "Automatically correlate frontend errors with backend logs and infrastructure metrics." },
        { icon: <FaServer />, title: "FE to BE Correlation", desc: "Trace user actions directly to database queries with full context propagation." },
      ].map((f, idx) => (

        <div
          key={idx}
          className="feature-card bg-surface-light dark:bg-surface-dark border border-border-color dark:border-border-dark rounded-xl p-5 shadow-sm"
        >

          <div className="w-8 h-8 rounded-lg gradient-icon-bg flex items-center justify-center mb-3 text-[#FF3131]">
            {f.icon}
          </div>

          <h4 className="font-bold text-sm text-text-main dark:text-white mb-1.5">
            {f.title}
          </h4>

          <p className="text-xs text-text-muted leading-relaxed">
            {f.desc}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>
    
    {/* Mobile Monitoring Section */}
<section className="scroll-mt-24 mt-6" id="mobile-monitoring">
  <div className="flex items-center gap-4 mb-6">
    <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 shadow-sm">
      <MdHub className="text-2xl" />
    </div>
    <h2 className="text-2xl font-bold text-text-main dark:text-white">
      B) MRUM Monitoring (Mobile Applications)
    </h2>
  </div>

  <div className="flex flex-col gap-10">
    {/* Mobile Performance Panel */}
    <div className="w-full bg-surface-light dark:bg-surface-dark p-1 rounded-xl shadow-xl border border-border-color dark:border-border-dark">
      <div className="bg-surface-light dark:bg-surface-dark rounded-lg overflow-hidden flex flex-col h-full min-h-[450px]">
        {/* Header Bar */}
        <div className="h-8 bg-surface-subtle dark:bg-surface-subtle-dark border-b border-border-color dark:border-border-dark flex items-center px-3 gap-2">
          <div className="flex gap-1.5">
            <div className="w-2.5 h-2.5 rounded-full bg-red-400"></div>
            <div className="w-2.5 h-2.5 rounded-full bg-amber-400"></div>
            <div className="w-2.5 h-2.5 rounded-full bg-green-400"></div>
          </div>
          <div className="flex-1 ml-2 bg-surface-light dark:bg-surface-dark/30 h-5 rounded flex items-center px-2 text-[10px] text-text-muted font-mono">
            Mobile Dashboard
          </div>
        </div>

        <div className="p-6 flex flex-col gap-8 flex-1">
          {/* Mobile Metrics */}
          <div className="grid grid-cols-2 gap-6">
            <div className="flex flex-col gap-2">
              <span className="text-xs font-bold uppercase text-text-muted tracking-wider">
                Frame Rendering (Jank)
              </span>
              <div className="relative w-full h-6 bg-surface-subtle dark:bg-surface-subtle-dark rounded">
                <div className="absolute top-0 left-0 h-6 w-[16%] bg-green-500 rounded"></div>
                <span className="absolute top-0 right-2 text-[10px] text-text-muted">
                  16ms Limit
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <span className="text-xs font-bold uppercase text-text-muted tracking-wider">
                Network Round-Trip
              </span>
              <div className="flex items-center justify-between">
                <span className="text-sm font-bold">4G LTE</span>
                <span className="text-sm font-bold">142ms</span>
              </div>
              <div className="h-2 bg-surface-subtle dark:bg-surface-subtle-dark rounded w-full mt-1">
                <div className="h-2 bg-blue-500 w-[25%] rounded"></div>
              </div>
            </div>
          </div>

          {/* Mobile Feature Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              { icon: <FaMobileAlt />, title: "Total UI/Front-End Health", desc: "Detect slow frames, frozen frames, and UI jank that disrupt user experience." },
              { icon: <FaMobileAlt />, title: "App & Version Distribution", desc: "Analyze performance across fragmented OS versions and device models." },
              { icon: <FaMobileAlt />, title: "Transactions & Sessions", desc: "Session Replay to watch exactly what led to an Application Not Responding (ANR)." },
              { icon: <FaMobileAlt />, title: "Service Map & Dependencies", desc: "Visualize 3rd party SDKs and API calls slowing down your mobile app." },
              { icon: <FaMobileAlt />, title: "Errors & Crashes", desc: "Detailed crash reporting with dSYM support and stack trace de-code." },
              { icon: <FaServer />, title: "Mobile to Backend Link", desc: "End-to-end trace ID propagation from the mobile device to the server." },
            ].map((f, idx) => (
              <div key={idx} className="feature-card bg-surface-light dark:bg-surface-dark border border-border-color dark:border-border-dark rounded-xl p-5 shadow-sm">
                <div className="w-8 h-8 rounded-lg gradient-icon-bg flex items-center justify-center mb-3 text-blue-500 dark:text-blue-400">
                  {f.icon}
                </div>
                <h4 className="font-bold text-sm text-text-main dark:text-white mb-1.5">{f.title}</h4>
                <p className="text-xs text-text-muted leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>

          {/* Comparison Table */}
          <div className="w-full overflow-x-auto mt-6">
            <h3 className="text-lg font-bold text-text-main dark:text-white mb-4">
              Comparison: Web vs. Mobile Monitoring
            </h3>
            <table className="min-w-full border-collapse border border-border-color dark:border-border-dark text-sm">
              <thead>
                <tr className="bg-surface-subtle dark:bg-surface-subtle-dark">
                  <th className="border border-border-color dark:border-border-dark px-3 py-2 text-left">Feature Category</th>
                  <th className="border border-border-color dark:border-border-dark px-3 py-2 text-left">Web Monitoring (RUM)</th>
                  <th className="border border-border-color dark:border-border-dark px-3 py-2 text-left">Mobile Monitoring (MRUM)</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { cat: "Tech Stack", web: "React, Angular, Vue, Vanilla JS", mobile: "iOS (Swift), Android (Kotlin), RN, Flutter" },
                  { cat: "Primary Metrics", web: "LCP, FID, CLS (Web Vitals)", mobile: "Frame Rates (FPS), Freeze Time, ANR" },
                  { cat: "Visibility Scope", web: "DOM Elements, XHR/Fetch, Assets", mobile: "Native UI Views, Device Hardware, Sensors" },
                  { cat: "Correlation", web: "W3C Trace Context (Headers)", mobile: "W3C Trace Context (Headers)" },
                  { cat: "Error Tracking", web: "Sourcemaps, Stack Traces", mobile: "dSYM/Mapping Files, Native Crashes" },
                ].map((row, idx) => (
                  <tr key={idx} className="even:bg-surface-subtle dark:even:bg-surface-subtle-dark">
                    <td className="border border-border-color dark:border-border-dark px-3 py-2 font-bold">{row.cat}</td>
                    <td className="border border-border-color dark:border-border-dark px-3 py-2">{row.web}</td>
                    <td className="border border-border-color dark:border-border-dark px-3 py-2">{row.mobile}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </div>
</section>

  </div>
);
}